import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { useFetch } from "@/hooks/useFetch";
import { fmtDate, fromNow } from "@/lib/time";
import { SalesHeader } from "@/components/sales/ui";

export default function Followups() {
  const { run } = useApp();
  const d = useFetch("/sales/followups");
  return (
    <div data-testid="followups-page">
      <SalesHeader title="My follow-ups" subtitle="Callbacks you've booked, plus next steps agreed on Insight calls." />
      <div className="grid gap-6 lg:grid-cols-2">
        <section className="rounded-2xl border bg-card/70 p-5">
          <h2 className="mb-3 font-display text-lg font-semibold">Callbacks</h2>
          {!d ? <div className="h-16 animate-pulse rounded-xl bg-white/[0.04]" /> : d.tasks.length === 0 ? <p className="text-sm text-muted-foreground">No callbacks booked.</p> : d.tasks.map((t) => (
            <div key={t.id} className="flex items-center gap-3 border-b py-3 last:border-0" data-testid={`followup-${t.id}`}>
              <button onClick={() => run(() => api.post(`/sales/followups/${t.id}/done`), "Follow-up done")} className="flex h-5 w-5 items-center justify-center rounded-full border-2 border-white/25 hover:border-emerald-400" data-testid={`followup-done-${t.id}`}><Check className="h-3 w-3 opacity-0 hover:opacity-100" /></button>
              <div className="min-w-0 flex-1"><Link to={`/sales/companies/${t.company_id}`} className="font-medium hover:text-cyan-300">{t.company_name || t.title}</Link>
                {t.details && <p className="truncate text-xs text-muted-foreground">{t.details}</p>}</div>
              <span className={`text-xs ${new Date(t.due_at) < new Date() ? "font-semibold text-amber-300" : "text-muted-foreground"}`}>{fmtDate(t.due_at)}</span>
            </div>
          ))}
        </section>
        <section className="rounded-2xl border bg-card/70 p-5">
          <h2 className="mb-3 font-display text-lg font-semibold">Next steps from Insight calls</h2>
          {!d ? <div className="h-16 animate-pulse rounded-xl bg-white/[0.04]" /> : d.insight_next_steps.length === 0 ? <p className="text-sm text-muted-foreground">No matched calls with next steps yet.</p> : d.insight_next_steps.map((c) => (
            <div key={c.id} className="border-b py-3 last:border-0" data-testid={`insight-followup-${c.id}`}>
              <Link to={`/sales/companies/${c.company_id}`} className="font-medium hover:text-cyan-300">{c.company_name}</Link>
              <p className="text-sm text-cyan-100">{c.next_steps}</p>
              <p className="text-xs text-muted-foreground">Call {fromNow(c.started_at)}</p>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
